export const translationOpenDrawer = {
  ar: {
    search: "بحث",
    clear: "مسح",
    categories: "الفئات",
    subCategories: "الفئات الفرعية",
    order: "ترتيب",
    "ascending A-Z": "تصاعدي A-Z",
    "descending Z-A": "تنازلي Z-A",
    "no sorting": "بدون ترتيب",
    selectCategory: "اختر الفئة",
  },
  cz: {
    search: "Hledat",
    clear: "Vyčistit",
    categories: "Kategorie",
    subCategories: "Podkategorie",
    order: "Pořadí",
    "ascending A-Z": "Vzestupně A-Z",
    "descending Z-A": "Sestupně Z-A",
    "no sorting": "Bez řazení",
    selectCategory: "Vyberte kategorii",
  },
  en: {
    search: "Search",
    clear: "Clear",
    categories: "Categories",
    subCategories: "Subcategories",
    order: "Order",
    "ascending A-Z": "Ascending A-Z",
    "descending Z-A": "Descending Z-A",
    "no sorting": "No sorting",
    selectCategory: "Select category",
  },
  de: {
    search: "Suchen",
    clear: "Leeren",
    categories: "Kategorien",
    subCategories: "Unterkategorien",
    order: "Reihenfolge",
    "ascending A-Z": "Aufsteigend A-Z",
    "descending Z-A": "Absteigend Z-A",
    "no sorting": "Keine Sortierung",
    selectCategory: "Kategorie auswählen",
  },
  es: {
    search: "Buscar",
    clear: "Limpiar",
    categories: "Categorías",
    subCategories: "Subcategorías",
    order: "Orden",
    "ascending A-Z": "Ascendente A-Z",
    "descending Z-A": "Descendente Z-A",
    "no sorting": "Sin ordenar",
    selectCategory: "Seleccionar categoría",
  },
  fr: {
    search: "Rechercher",
    clear: "Effacer",
    categories: "Catégories",
    subCategories: "Sous-catégories",
    order: "Ordre",
    "ascending A-Z": "Croissant A-Z",
    "descending Z-A": "Décroissant Z-A",
    "no sorting": "Aucun tri",
    selectCategory: "Sélectionner la catégorie",
  },
  hu: {
    search: "Keresés",
    clear: "Töröl",
    categories: "Kategóriák",
    subCategories: "Alkategóriák",
    order: "Sorrend",
    "ascending A-Z": "Növekvő A-Z",
    "descending Z-A": "Csökkenő Z-A",
    "no sorting": "Nincs rendezés",
    selectCategory: "Kiválasztott kategóriá kiválasztása",
  },
  nl: {
    search: "Zoeken",
    clear: "Wissen",
    categories: "Categorieën",
    subCategories: "Subcategorien",
    order: "Volgorde",
    "ascending A-Z": "Oplopend A-Z",
    "descending Z-A": "Aflopend Z-A",
    "no sorting": "Geen sortering",
    selectCategory: "Selecteer categorie",
  },
  pl: {
    search: "Szukaj",
    clear: "Wyczyść",
    categories: "Kategorie",
    subCategories: "Podkategorie",
    order: "Kolejność",
    "ascending A-Z": "Rosnąco A-Z",
    "descending Z-A": "Malejąco Z-A",
    "no sorting": "Bez sortowania",
    selectCategory: "Wybierz kategorie",
  },
  ru: {
    search: "Поиск",
    clear: "Очистить",
    categories: "Категории",
    subCategories: "Подкатегории",
    order: "Порядок",
    "ascending A-Z": "По возрастанию A-Я",
    "descending Z-A": "По убыванию Я-А",
    "no sorting": "Без сортировки",
    selectCategory: "Выберите категорию",
  },
  sk: {
    search: "Hľadať",
    clear: "Vymazať",
    categories: "Kategórie",
    subCategories: "Podkategórie",
    order: "Poradie",
    "ascending A-Z": "Vzostupne A-Z",
    "descending Z-A": "Zostupne Z-A",
    "no sorting": "Bez triedenia",
    selectCategory: "Zvoľte kategóriu",
  },
  sv: {
    search: "Sök",
    clear: "Rensa",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "Ordning",
    "ascending A-Z": "Stigande A-Z",
    "descending Z-A": "Fallande Z-A",
    "no sorting": "Ingen sortering",
    selectCategory: "Välj kategori",
  },
  no: {
    search: "Søk",
    clear: "Tøm",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "Rekkefølge",
    "ascending A-Z": "Stigende A-Z",
    "descending Z-A": "Synkende Z-A",
    "no sorting": "Ingen sortering",
    selectCategory: "Velg kategori",
  },
  da: {
    search: "Søg",
    clear: "Ryd",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "Rækkefølge",
    "ascending A-Z": "Stigende A-Z",
    "descending Z-A": "Faldende Z-A",
    "no sorting": "Ingen sortering",
    selectCategory: "Vælg kategori",
  },
  fi: {
    search: "Hae",
    clear: "Tyhjennä",
    categories: "Kategoriat",
    subCategories: "Alakategoriat",
    order: "Järjestys",
    "ascending A-Z": "Nouseva A-Z",
    "descending Z-A": "Laskeva Z-A",
    "no sorting": "Ei järjestystä",
    selectCategory: "Valitse kategoria",
  },
};

export default translationOpenDrawer;
